import * as React from 'react';
import styled from 'styled-components';

import { Hue } from '@process-advisor/process-miner/components/colorPicker/hue';
import { Saturation } from '@process-advisor/process-miner/components/colorPicker/saturation';
import { EditableInput } from '@process-advisor/process-miner/components/colorPicker/editableInput';
import { Alpha } from '@process-advisor/process-miner/components/colorPicker/alpha';
import { getShadow } from '@process-advisor/process-miner/shared/theme';

const Container = styled.div`
    width: 100%;
`;

const SlidersWithPreview = styled.div`
    display: flex;
    align-items: center;
    margin-top: 4px;
`;

const Sliders = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 4px;
`;

const Preview = styled.div<{ color: string }>`
    width: 24px;
    height: 24px;
    background-color: ${({ color }) => color};
    border-radius: 2px;
    box-shadow: ${getShadow('slider')};
`;

type Props = {
    activeColor: string;
    onColorChange: (color: string) => void;
};

export const CustomColorPicker: React.FC<Props> = ({
    activeColor,
    onColorChange,
}) => (
    <Container>
        <Saturation
            activeColor={activeColor}
            onColorChange={onColorChange} />
        <SlidersWithPreview>
            <Sliders>
                <Hue
                    activeColor={activeColor}
                    onColorChange={onColorChange} />
                <Alpha
                    activeColor={activeColor}
                    onColorChange={onColorChange} />
            </Sliders>
            <Preview color={activeColor} />
        </SlidersWithPreview>
        <EditableInput
            activeColor={activeColor}
            onColorChange={onColorChange} />
    </Container>
);
